var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "chat-widget",
    class: {
      open: _vm.isOpen
    }
  }, [!_vm.isOpen ? _c('div', {
    staticClass: "chat-trigger",
    on: {
      "click": _vm.openChat
    }
  }, [_c('svg', {
    staticClass: "trigger-icon",
    attrs: {
      "viewBox": "0 0 24 24",
      "aria-hidden": "true"
    }
  }, [_c('path', {
    attrs: {
      "d": "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 9h12v2H6V9zm8 5H6v-2h8v2zm0-6H6V6h8v2z"
    }
  })]), _c('span', {
    staticClass: "trigger-text"
  }, [_vm._v("在线咨询")])]) : _c('div', {
    staticClass: "chat-window"
  }, [_c('div', {
    staticClass: "chat-header"
  }, [_c('div', {
    staticClass: "header-info"
  }, [_c('div', {
    staticClass: "avatar"
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 24 24",
      "width": "20",
      "height": "20",
      "fill": "#fff",
      "aria-hidden": "true"
    }
  }, [_c('path', {
    attrs: {
      "d": "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z"
    }
  })])]), _vm._m(0)]), _c('div', {
    staticClass: "header-actions"
  }, [_c('i', {
    staticClass: "el-icon-minus action-icon",
    attrs: {
      "title": "收起"
    },
    on: {
      "click": _vm.closeChat
    }
  }), _c('i', {
    staticClass: "el-icon-close action-icon",
    attrs: {
      "title": "关闭"
    },
    on: {
      "click": _vm.closeChat
    }
  })])]), _c('div', {
    ref: "messageListRef",
    staticClass: "chat-body"
  }, [_vm._l(_vm.messages, function (msg, idx) {
    return _c('div', {
      key: idx,
      staticClass: "message-item",
      class: msg.sender
    }, [_c('div', {
      staticClass: "message-avatar"
    }, [msg.sender === 'ROBOT' || msg.sender === 'SYSTEM' || msg.sender === 'AGENT' ? _c('svg', {
      attrs: {
        "viewBox": "0 0 24 24",
        "width": "20",
        "height": "20",
        "fill": "#fff",
        "aria-hidden": "true"
      }
    }, [_c('path', {
      attrs: {
        "d": "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z"
      }
    })]) : _c('svg', {
      attrs: {
        "viewBox": "0 0 24 24",
        "width": "20",
        "height": "20",
        "fill": "#fff",
        "aria-hidden": "true"
      }
    }, [_c('path', {
      attrs: {
        "d": "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
      }
    })])]), _c('div', {
      staticClass: "message-content"
    }, [_c('div', {
      staticClass: "message-bubble",
      domProps: {
        "innerHTML": _vm._s(_vm.formatMessage(msg.content))
      }
    }), _c('div', {
      staticClass: "message-time"
    }, [_vm._v(_vm._s(_vm.formatTime(msg.timestamp)))])])]);
  }), _vm.typing ? _c('div', {
    staticClass: "message-item robot"
  }, [_c('div', {
    staticClass: "message-avatar"
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 24 24",
      "width": "20",
      "height": "20",
      "fill": "#fff",
      "aria-hidden": "true"
    }
  }, [_c('path', {
    attrs: {
      "d": "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z"
    }
  })])]), _vm._m(1)]) : _vm._e()], 2), _vm.quickReplies.length > 0 ? _c('div', {
    staticClass: "chat-quick-replies"
  }, [_c('div', {
    staticClass: "quick-replies-list"
  }, _vm._l(_vm.quickReplies, function (btn) {
    return _c('el-button', {
      key: btn.id,
      staticClass: "quick-reply-btn",
      attrs: {
        "type": btn.triggerType === 'PHONE_COLLECT' ? 'primary' : 'default',
        "plain": "",
        "size": "small"
      },
      on: {
        "click": function ($event) {
          return _vm.handleButtonClick(btn);
        }
      }
    }, [_vm._v(" " + _vm._s(btn.buttonName) + " ")]);
  }), 1)]) : _vm._e(), _c('div', {
    staticClass: "chat-footer"
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入消息...",
      "disabled": !_vm.connected,
      "clearable": ""
    },
    nativeOn: {
      "keydown": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.handleSendText.apply(null, arguments);
      }
    },
    model: {
      value: _vm.inputText,
      callback: function ($$v) {
        _vm.inputText = $$v;
      },
      expression: "inputText"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-position",
      "disabled": !_vm.inputText.trim() || !_vm.connected
    },
    on: {
      "click": _vm.handleSendText
    },
    slot: "append"
  }, [_vm._v(" 发送 ")])], 1), _c('div', {
    staticClass: "footer-tip"
  }, [_c('span', {
    staticClass: "tip-dot",
    class: {
      ok: _vm.connected,
      bad: !_vm.connected
    }
  }), _vm._v(" " + _vm._s(_vm.connected ? '已连接' : '连接中...') + " ")])], 1)])]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "info-text"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("智能客服小助手")]), _c('div', {
    staticClass: "status"
  }, [_c('span', {
    staticClass: "status-dot"
  }), _vm._v(" 在线服务")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "message-content"
  }, [_c('div', {
    staticClass: "message-bubble typing"
  }, [_c('span', {
    staticClass: "dot"
  }), _c('span', {
    staticClass: "dot"
  }), _c('span', {
    staticClass: "dot"
  })])]);
}];
export { render, staticRenderFns };